/* ============
 * Algolia Search
 * ============
 *
 * https://github.com/algolia/algoliasearch-client-javascript
 */

import Vue from 'vue'
import algoliasearch from 'algoliasearch'

const client = algoliasearch(process.env.ALGOLIA_APP_ID, process.env.ALGOLIA_API_KEY)

Vue.$algoliasearch = client
Object.defineProperty(Vue.prototype, '$algoliasearch', {
  get () {
    return client
  }
})



// WEBPACK FOOTER //
// ./src/app/plugins/algoliasearch.js